import { render, staticRenderFns } from "./SuccessfulMatch.vue?vue&type=template&id=7e80eadd&scoped=true&"
import script from "./SuccessfulMatch.vue?vue&type=script&lang=js&"
export * from "./SuccessfulMatch.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulMatch.vue?vue&type=style&index=0&id=7e80eadd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e80eadd",
  null
  
)

export default component.exports